import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Vue, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import { Guid } from "guid-typescript";
import simplebar from "simplebar-vue";
import { interpret } from "xstate";
import Swal from "sweetalert2";
import { toaster } from "@/utilities/toaster";
import VueApexChart from "vue-apexcharts";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Timer from "@/components/clockWork/timer.vue";
import HeartBeat from "@/components/heart-beat.vue";
import clockPicker from "@/components/widgets/clockPicker.vue";
import clockWorkMachine from "./machines/clockWorkMachine";
import { ClockWorkEntryModel } from "../../../store/models/clockWork/clockWorkEntry";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { ProjectModule } from "@/store/modules/project.module";
import { PMOTaskCreationModel } from "@/store/models/project/PMOTaskCreation";
import TimeLine from "@/components/clockWork/timeLineComponent.vue";
import ClockWorkSearch from "@/components/clockWork/clockWorkSearch.vue";
import Switches from "vue-switches";
import { ClockWorkSettingRequestModel } from "@/store/models/project/request/clockWorkSettingRequest";
import ClockWorkPieChart from "@/components/clockWork/clockWorkPieChart.vue";
import { format } from "date-fns";
import { clearInterval, setInterval } from "worker-timers";
import AdjustEntrySlider from "@/components/clockWork/adjustEntrySlider.vue";
Component.registerHooks(["metaInfo"]);
let ClockWork = /** @class */ (() => {
    let ClockWork = class ClockWork extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "ClockWork";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Apps",
                    href: "#",
                },
                {
                    text: "ClockWork",
                    active: true,
                },
            ];
            this.today = new Date();
            this.showSettingsCard = false;
            this.showCwHelpList = false;
            this.entryDate = new Date();
            this.liveTime = 0;
            this.firstTime = true;
            this.Interval = 0;
            this.isButtonDisabled = true;
            this.showKS = false;
            // MACHINE
            this.machine = clockWorkMachine.withContext({
                operationDate: new Date(),
                displayDate: new Date(),
                checkedEntries: [],
                associationMachine: null,
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.checkAll = false;
            this.checkedEntries = [];
            this.task = new PMOTaskCreationModel();
            this.entry = new ClockWorkEntryModel();
            this.selectedProjectId = Guid.createEmpty();
            this.selectedTaskId = Guid.createEmpty();
            this.clockWorkSettingRequest = new ClockWorkSettingRequestModel();
            this.isClockWorkWeeklyMail = false;
            this.isWFO = false;
            this.projectSearchKey = "";
            this.taskSearchKey = "";
            this.fixEndTime = "";
            this.startTime = "";
            this.adjustedStartTime = "";
            this.adjustedEndTime = "";
            this.splittedTime = "";
            this.deleteId = [];
            this.projectId = Guid.createEmpty();
            this.taskId = Guid.createEmpty();
            this.emptyGuid = Guid.createEmpty();
            this.entryId = Guid.createEmpty();
            this.showLongRunningEntry = false;
            this.gapFillMsg = "Click to set this time as ";
            this.gapFillMsgDown = " to fix the gap with the entry below.";
            this.gapFillMsgUp = " to fix the gap with the entry above.";
            this.isAM = false;
            this.isAMorPM = false;
            this.projectPieChart = false;
            this.selectedProjectName = "";
            this.selectedTaskName = "";
            this.formattedDate = {
                dateOfMonth: "",
                suffixOfDate: "",
                month: "",
                year: "",
                day: "",
            };
            this.manageEntriesSliderModified = false;
            this.currentRunningEntry = null;
        }
        metaInfo() {
            return {
                title: "SystemOne - ClockWork",
            };
        }
        // METHODS
        addEntry() {
            this.send({ type: "START" });
        }
        selectedEntryIndex() {
            return _.findIndex(this.entries, (x) => x.id == this.selectedEntry.id);
        }
        prevEntry() {
            //mapped to J, prev entry in Time
            if (this.selectedEntry != null) {
                var entryIndex = this.selectedEntryIndex();
                if (entryIndex < this.entries.length) {
                    this.send({
                        type: "PREV_ENTRY",
                        prevEntryId: this.entries[entryIndex + 1].id,
                    });
                }
            }
        }
        nextEntry() {
            //mapped to K, next entry in Time
            if (this.selectedEntry != null) {
                var entryIndex = this.selectedEntryIndex();
                if (entryIndex > 0) {
                    this.send({
                        type: "NEXT_ENTRY",
                        nextEntryId: this.entries[entryIndex - 1].id,
                    });
                }
                else if (entryIndex == 0 && this.isActive) {
                    this.send({ type: "NEXT_ENTRY", nextEntryId: this.activeEntry.id });
                }
            }
        }
        prevDay() {
            this.send({ type: "PREV_DAY" });
        }
        nextDay() {
            if (!this.isToday) {
                this.send({ type: "NEXT_DAY" });
            }
        }
        restartEntry(entryToStart) {
            entryToStart.totalTimeInSeconds = parseInt(entryToStart.totalTimeInSeconds);
            this.send({ type: "RESTART", entry: entryToStart });
        }
        workStatusUpdate(entry) {
            const guid = entry.id;
            const guidArray = [guid];
            entry.entryAtWork = !entry.entryAtWork;
            this.send({ type: "SWITCH_WORK_STATUS", entryId: guidArray, isWFO: entry.entryAtWork });
        }
        deleteEntry(entryToDelete) {
            Swal.fire({
                title: `Delete Entry?`,
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    this.send({ type: "DELETE", entryId: entryToDelete.toString() });
                }
            });
        }
        updateEntry() {
            this.activeEntry.totalTimeInSeconds = Math.floor(this.activeEntry.totalTimeInSeconds);
            ClockWorkModule.UpdateEntry(this.activeEntry).then((response) => { });
        }
        updateSelectedEntry() {
            this.selectedEntry.totalTimeInSeconds = Math.floor(this.selectedEntry.totalTimeInSeconds);
            this.validate("editEntryObserver").then((response) => {
                if (response) {
                    ClockWorkModule.UpdateEntry(this.selectedEntry).then((response) => { });
                }
            });
        }
        endEntry() {
            this.activeEntry.totalTimeInSeconds = Math.floor(this.activeEntry.totalTimeInSeconds);
            this.send({ type: "STOP", liveEntry: this.activeEntry });
        }
        goToday() {
            if (!this.isToday)
                this.send({ type: "GO_TO_TODAY" });
        }
        // EVENTS
        displayDateChanged(value) {
            if (value !== null) {
                this.send({ type: "CHANGE_DISPLAY_DATE", value: value });
            }
        }
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > new Date(today.getTime());
        }
        send(event) {
            this.machineService.send(event);
        }
        setToday() {
            this.today = new Date();
            this.goToday();
        }
        closeSidePanel() {
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection")) {
                this.validate("editEntryObserver").then((response) => {
                    if (response) {
                        this.send({ type: "CLEAR_ENTRY_SELECTIONS" });
                    }
                });
            }
            else {
                this.send({ type: "CLEAR_ENTRY_SELECTIONS" });
            }
        }
        toggleAllEntries(e) {
            this.checkAll = !this.checkAll;
            if (this.checkAll) {
                for (var i = 0; i < this.allEntriesForTheDay.length; i++) {
                    if (!this.checkedEntries.includes(this.allEntriesForTheDay[i].id)) {
                        this.send({
                            type: "ENTRY_TOGGLE",
                            entryId: this.allEntriesForTheDay[i].id.toString(),
                        });
                    }
                }
                this.checkedEntries = [];
                this.allEntriesForTheDay.map((x) => {
                    this.checkedEntries.push(x.id.toString());
                });
            }
            else {
                this.send({ type: "CLEAR_ENTRY_SELECTIONS" });
            }
        }
        checkBoxOnInput(ev) {
            if (this.selectedEntry != null && this.selectedEntry.description == "") {
                this.selectedEntry.description = this.selectedEntry.description == "" ? "Untitled Entry" : this.selectedEntry.description;
            }
            this.checkedEntries.length == this.allEntriesForTheDay.length ? (this.checkAll = true) : (this.checkAll = false);
            this.send({ type: "ENTRY_TOGGLE", entryId: ev.target.value });
        }
        singleSelectEntry(entryId) {
            if (this.checkedEntries.length === 1 && this.checkedEntries[0] == entryId) {
                this.selectedEntry.description = this.selectedEntry.description == "" ? "Untitled Entry" : this.selectedEntry.description;
                this.send({ type: "CLEAR_ENTRY_SELECTIONS" });
            }
            else {
                if (this.selectedEntry != null && this.selectedEntry.description == "") {
                    this.selectedEntry.description = this.selectedEntry.description == "" ? "Untitled Entry" : this.selectedEntry.description;
                }
                this.send({ type: "CLEAR_ENTRY_SELECTIONS" });
                this.send({ type: "ENTRY_TOGGLE", entryId: entryId });
            }
        }
        confirmDelete() {
            Swal.fire({
                title: `Delete ${this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection") ? "Entry?" : this.checkedEntries.length + " " + "Entries?"}`,
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    this.send({ type: "CHECKED_ENTRY_DELETE" });
                }
            });
        }
        confirmRunningEntriesDelete(entryId) {
            Swal.fire({
                title: `Delete Running Entry?`,
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    this.send({ type: "DELETE_RUNNING_ENTRY", deleteId: entryId });
                }
            });
        }
        onTabChange(e) {
            this.send({ type: "UPDATE_PICKER", value: e });
            this.clearProjectTaskSelections();
        }
        preselectProjectTaskCombo() {
            var that = this;
            function preSelect() {
                that.projectTaskCombos.map((x) => {
                    if (x.projectName == projectName && x.taskName == taskName) {
                        that.selectedTaskId = x.taskId;
                    }
                });
            }
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection")) {
                var projectName = this.selectedEntry.projectDisplayString.split("-")[1];
                var taskName = this.selectedEntry.taskDisplayString.split("-")[1];
                preSelect();
            }
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.multiSelection")) {
                if (this.multiEntriesHaveSameCombo) {
                    var firstCheckedEntry = this.allEntriesForTheDay.find((x) => this.checkedEntries.indexOf(x.id) > -1);
                    var projectName = firstCheckedEntry.projectDisplayString.split("-")[1];
                    var taskName = firstCheckedEntry.taskDisplayString.split("-")[1];
                    preSelect();
                }
            }
        }
        fetchTasksForProject(projectitem) {
            this.send({ type: "FETCH_TASKS", projectId: projectitem.id });
            this.selectedProjectId = projectitem.id;
            this.selectedTaskId = Guid.createEmpty();
            this.taskId = Guid.createEmpty();
            this.taskSearchKey = "";
        }
        createTaskUnderProject() {
            this.reset("searchProjectTaskComboObserver");
            this.validateProvider("searchProjectValidator").then((response) => {
                if (response.valid) {
                    this.validate("taskNameObserver").then((response2) => {
                        if (response2) {
                            this.task.projectId = this.selectedProjectId.toString();
                            this.task.taskName = this.taskSearchKey;
                            ProjectModule.CreateTaskUnderProject(this.task).then((response) => {
                                this.send({
                                    type: "FETCH_TASKS",
                                    projectId: this.selectedProjectId,
                                });
                                this.selectedTaskId = response.id;
                                this.taskSearchKey = "";
                            });
                        }
                    });
                }
            });
        }
        clearProjectTaskSelections() {
            this.selectedProjectId = Guid.createEmpty();
            this.selectedTaskId = Guid.createEmpty();
            this.taskId = Guid.createEmpty();
            this.projectSearchKey = "";
            this.taskSearchKey = "";
        }
        saveProjectTaskAssociation() {
            var that = this;
            let opertionMode = this.state.context.associationMachine.state.context.operationMode;
            switch (opertionMode) {
                case 0:
                    this.validate("recentProjectTaskComboObserver").then((response) => {
                        if (response) {
                            this.send({ type: "ASSIGN", taskId: this.selectedTaskId });
                        }
                    });
                    break;
                case 1:
                    this.validate("searchProjectTaskComboObserver").then((response) => {
                        if (response) {
                            this.send({ type: "ASSIGN", taskId: this.selectedTaskId });
                        }
                    });
                    break;
                case 2:
                    this.validate("createProjectTaskComboObserver").then((response) => {
                        if (response) {
                            ProjectModule.CreateProjectTaskCombo().then((response) => {
                                this.send({ type: "ASSIGN", taskId: response });
                            });
                        }
                    });
                    break;
                default:
                    break;
            }
        }
        showAdjustEntry() {
            this.adjustedStartTime = this.selectedEntry.startTimeTzFormatted.toUpperCase();
            this.adjustedEndTime = this.selectedEntry.endTimeTzFormatted.toUpperCase();
            this.send({ type: "ADJUST_ENTRY" });
        }
        saveAdjustedEntry() {
            this.send({
                type: "SAVE_ADJUSTED_ENTRY",
                entryId: this.selectedEntry.id,
                newStartTime: this.adjustedStartTime,
                newEndTime: this.adjustedEndTime,
            });
        }
        // Split Entry.
        showSplitEntry(entryId) {
            this.splittedTime = "";
            this.isAMorPM = false;
            this.isAM = false;
            this.entryAmorPmChecking(entryId);
            this.send({ type: "SPLIT_ENTRY" });
        }
        entryAmorPmChecking(entryId) {
            var findEntry = this.entries.find((x) => x.id == entryId);
            var startTimeTz = findEntry.startTimeTzFormatted.split(/:|\s/);
            var endTimeTz = findEntry.endTimeTzFormatted.split(/:|\s/);
            this.isAMorPM = startTimeTz[2] === endTimeTz[2];
            if (this.isAMorPM) {
                this.isAM = startTimeTz[2] === "am";
            }
        }
        saveSplittedEntry() {
            const date = new Date().toLocaleDateString();
            const startTime = new Date(date + " " + this.selectedEntry.startTimeTzFormatted);
            const endTime = new Date(date + " " + this.selectedEntry.endTimeTzFormatted);
            const splitTime = new Date(date + " " + this.splittedTime.toLowerCase());
            const startTimeValueAsMinutes = startTime.getHours() * 60 + startTime.getMinutes();
            const endTimeValueAsMinutes = endTime.getHours() * 60 + endTime.getMinutes();
            const splitTimeValueAsMinutes = splitTime.getHours() * 60 + splitTime.getMinutes();
            if (splitTimeValueAsMinutes <= startTimeValueAsMinutes || splitTimeValueAsMinutes >= endTimeValueAsMinutes) {
                toaster.ShowError("Split time is not within the required range between Start and End Times.");
            }
            else if (splitTimeValueAsMinutes - startTimeValueAsMinutes < 6) {
                toaster.ShowError("Split time should be at least 6 minutes from the Start Time.");
            }
            else if (endTimeValueAsMinutes - splitTimeValueAsMinutes < 6) {
                toaster.ShowError("Split time should be at least 6 minutes before the End Time.");
            }
            else {
                this.send({
                    type: "SAVE_SPLITTED_ENTRY",
                    entryId: this.selectedEntry.id,
                    splitTime: this.splittedTime,
                });
            }
        }
        saveFixTime(entryId) {
            var currentEntry = this.runningEntries.find((x) => x.clockWorkEntry.id == entryId);
            this.startTime = currentEntry.clockWorkEntry.startTimeTzFormatted.toUpperCase();
            this.fixEndTime = currentEntry.clockWorkEntry.endTimeTzFormatted.toUpperCase();
            this.send({
                type: "FIXING_ENTRY",
                entryId: entryId,
                newStartTime: this.startTime,
                newEndTime: this.fixEndTime,
            });
        }
        endAndContinue(entryId) {
            var currentEntry = this.runningEntries.find((x) => x.clockWorkEntry.id == entryId);
            Swal.fire({
                title: `Confirm the following changes`,
                text: "As this time entry is crossing over to the next day, separate entries will be created for each day.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#556EE6",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Okay",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.value) {
                    this.startTime = currentEntry.clockWorkEntry.startTimeTzFormatted.toUpperCase();
                    currentEntry.clockWorkEntry.endTimeTzFormatted = "11:59 PM";
                    this.send({
                        type: "CROSSOVER",
                        runningEntry: currentEntry.clockWorkEntry,
                    });
                }
            });
        }
        // Default Project and Task
        showSettingMenu() {
            this.isButtonDisabled = true;
            this.isClockWorkWeeklyMail = this.isClockWorkSetWeeklyMail;
            this.isWFO = this.isWorkFromOffice;
            this.clockWorkSettingRequest.isWFO = this.isWFO;
            this.clockWorkSettingRequest.isClockWorkSetWeeklyMail = this.isClockWorkWeeklyMail;
            this.showSettingsCard = true;
            this.machineService.send({ type: "DEFAULT_SETTING" });
        }
        changesInDefaultClockWorkSettings() {
            if (this.showSettingsCard == true) {
                this.UpdateButtonState();
            }
        }
        UpdateButtonState() {
            let task = null;
            if (this.selectedTaskName !== "") {
                const pattern = /(\d+)/;
                const match = this.selectedTaskName.match(pattern);
                if (match && match[1]) {
                    task = ProjectModule.allTasksForDefault.find((task) => task.code === match[1]);
                    if (task) {
                        this.isButtonDisabled = false;
                    }
                }
            }
            if (this.isClockWorkWeeklyMail != this.clockWorkSettingRequest.isClockWorkSetWeeklyMail) {
                this.isButtonDisabled = false;
            }
            else if (this.isWFO != this.clockWorkSettingRequest.isWFO) {
                this.isButtonDisabled = false;
            }
        }
        tasksForSelectedProject() {
            var project;
            if (this.selectedProjectName != "") {
                const pattern = /(\d+)/;
                const match = this.selectedProjectName.match(pattern);
                project = ProjectModule.allProjectsForDefault.find((project) => project.code === match[1]);
            }
            if (project != null || project != undefined) {
                this.machineService.send({
                    type: "SELECTING_PROJECT",
                    projectId: project.id,
                });
            }
        }
        saveDefaultProjectAndTask() {
            var task;
            if (this.selectedTaskName != "") {
                const pattern = /(\d+)/;
                const match = this.selectedTaskName.match(pattern);
                task = ProjectModule.allTasksForDefault.find((task) => task.code === match[1]);
            }
            this.clockWorkSettingRequest.isClockWorkSetWeeklyMail = this.isClockWorkWeeklyMail;
            this.clockWorkSettingRequest.isWFO = this.isWFO;
            if (task != null || task != undefined) {
                this.clockWorkSettingRequest.taskId = task.id.toString();
            }
            else {
                this.clockWorkSettingRequest.taskId = this.emptyGuid.toString();
            }
            this.machineService.send({
                type: "SAVE_DEFAULT_PROJECT_TASK",
                clockWorkSettingRequest: this.clockWorkSettingRequest,
            });
            this.showSettingsCard = false;
            this.isButtonDisabled = true;
        }
        cancelDefaultProjectAndTask() {
            this.isButtonDisabled = true;
            this.taskId = Guid.createEmpty();
            this.projectId = Guid.createEmpty();
            this.machineService.send({ type: "CANCEL_DEFAULT_PROJECT_TASK" });
            this.showSettingsCard = false;
            this.selectedTaskName = "";
            this.selectedProjectName = "";
        }
        removeDefaultProjectAndTask() {
            this.machineService.send({ type: "REMOVE_DEFAULT_PROJECT_TASK" });
            toaster.ShowSuccess("Default Project and Task was removed successfully.");
        }
        SetDefaultProjectAndTask(selectedEntry) {
            this.clockWorkSettingRequest.fromSettings = false;
            this.clockWorkSettingRequest.taskId = selectedEntry.taskId.toString();
            this.machineService.send({
                type: "SET_DEFAULT_PROJECT_TASK",
                clockWorkSettingRequest: this.clockWorkSettingRequest,
            });
        }
        //Gap Filling
        DownFill(entry) {
            entry.totalTimeInSeconds = Math.floor(entry.totalTimeInSeconds);
            if (entry.downFillApplicable) {
                this.machineService.send({
                    type: "DOWNFILL",
                    payload: entry,
                });
            }
        }
        UpFill(entry) {
            entry.totalTimeInSeconds = Math.floor(entry.totalTimeInSeconds);
            if (entry.upFillApplicable) {
                this.machineService.send({
                    type: "UPFILL",
                    payload: entry,
                });
            }
        }
        getStartingTitleMessage(entry) {
            if (entry.downFillApplicable) {
                return this.gapFillMsg + entry.downFillHover + this.gapFillMsgDown;
            }
            return "";
        }
        getEndingTitleMessage(entry) {
            if (entry.upFillApplicable) {
                return this.gapFillMsg + entry.upFillHover + this.gapFillMsgUp;
            }
            return "";
        }
        goToProjectOverView(projectId) {
            if (projectId != null) {
                this.$router.push({
                    name: "ProjectOverview",
                    params: { projectId: projectId },
                });
            }
        }
        GoToProjectOverView(projectId, isMember) {
            if (projectId != null) {
                if (isMember) {
                    this.$router.push({
                        name: "ProjectOverview",
                        params: { projectId: projectId },
                    });
                }
                else {
                    Swal.fire({
                        text: "Sorry! You do not have access to view this Project.",
                        icon: "warning",
                        confirmButtonColor: "#34C38F",
                        confirmButtonText: "Okay",
                    }).then(() => { });
                }
            }
        }
        // Check if the MNCO time is AM or PM
        checkingAMOrPM(entryId) {
            var currentEntry = this.runningEntries.find((x) => x.clockWorkEntry.id == entryId);
            var value = currentEntry.clockWorkEntry.startTimeTzFormatted.split(/:|\s/);
            this.isAMorPM = value[2] === "pm";
            if (this.isAMorPM) {
                this.isAM = false;
            }
        }
        //Search
        showCWSearchFlap() {
            let cwSearch = this.$refs["clockWorkSearchRef"];
            cwSearch.showModal();
        }
        CWHelpList() {
            this.showCwHelpList = true;
        }
        closeHelpList() {
            this.showCwHelpList = false;
        }
        closeSettingsCard() {
            this.isButtonDisabled = true;
            this.taskId = Guid.createEmpty();
            this.projectId = Guid.createEmpty();
            this.selectedTaskName = "";
            this.selectedProjectName = "";
            this.showSettingsCard = false;
        }
        //WFH
        UpdateWFO() {
            this.machineService.send({
                type: "SWITCH_WORK",
                isWFO: true,
            });
        }
        UpdateWFH() {
            this.machineService.send({
                type: "SWITCH_WORK",
                isWFO: false,
            });
        }
        getFormattedDateString(value) {
            return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
        }
        getStartOfWeek(selectedDate) {
            let diff = selectedDate.getDay() - 1;
            if (diff < 0) {
                diff += 7;
            }
            return new Date(selectedDate.getTime() - diff * 24 * 60 * 60 * 1000);
        }
        getEndOfWeek(selectedDate) {
            let diff = 7 - selectedDate.getDay();
            return new Date(selectedDate.getTime() + diff * 24 * 60 * 60 * 1000);
        }
        CWPiechart() {
            let cwPieChart = this.$refs["clockWorkPieChartRef"];
            cwPieChart.showModal();
        }
        TimeInterval() {
            this.Interval = setInterval(() => {
                if (this.activeEntry) {
                    const istOffset = 5 * 60 + 30; // IST offset in minutes
                    const endTimeInSeconds = this.activeEntry.endTime ? new Date(this.activeEntry.endTime).getTime() + istOffset * 60 * 1000 : Date.now();
                    const startTimeInSeconds = new Date(this.activeEntry.startTime).getTime() + istOffset * 60 * 1000;
                    this.liveTime = (endTimeInSeconds - startTimeInSeconds) / 1000;
                }
            }, 1000);
        }
        openAdjustSlider() {
            if (this.allEntriesForTheDay.length > 0) {
                this.$bvModal.show("adjust-slider");
            }
        }
        closeAdjustSlider() {
            this.$bvModal.hide("adjust-slider");
            var adjustEntrySlider = this.$refs["adjustEntrySlider"];
            if (adjustEntrySlider.IsSavedSuccessFul()) {
                this.send({
                    type: "CHANGE_DISPLAY_DATE",
                    value: this.state.context.displayDate,
                });
            }
        }
        closeSlider() {
            if (this.manageEntriesSliderModified) {
                Swal.fire({
                    customClass: {
                        container: "remove-swal2-container",
                        title: "remove-swal2-title",
                        popup: "remove-swal2-popup",
                        icon: "remove-swal2-icon",
                    },
                    text: `You won't be able to revert this!`,
                    icon: "warning",
                    title: "You have made changes. Do you want to discard or save them?",
                    showCancelButton: true,
                    confirmButtonColor: "#f46a6a",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                }).then((result) => {
                    if (result.value) {
                        this.saveAdjustEntrySilderValues();
                    }
                    else {
                        this.closeAdjustSlider();
                    }
                });
            }
            else {
                this.closeAdjustSlider();
            }
        }
        async saveAdjustEntrySilderValues() {
            var adjustEntrySlider = this.$refs["adjustEntrySlider"];
            await adjustEntrySlider.saveEntries();
        }
        toggleKsWindow() {
            this.showKS = !this.showKS;
        }
        closeKsWindow() {
            this.showKS = false;
        }
        // COMPUTED
        get projectDaySummaries() {
            return ClockWorkModule.projectDaySummaries;
        }
        get projectWeekSummaries() {
            return ClockWorkModule.projectWeekSummaries;
        }
        get allEntriesForTheDay() {
            return ClockWorkModule.entries.reverse();
        }
        get allWeekEntries() {
            return ClockWorkModule.weekEntries.reverse();
        }
        get totalEntries() {
            return this.entries.length + (this.isActive && this.isToday ? 1 : 0);
        }
        get totalWeekEntries() {
            return this.allWeekEntries.length + (this.isActive && this.isToday ? 1 : 0);
        }
        // get dateFormatEntries() {
        //     const date = new Date(this.anyRunningData.startTime);
        //     const options = { weekday: "long", year: "numeric", month: "short", day: "numeric" };
        //     return date.toLocaleString("en-US", options);
        // }
        get hasEntries() {
            return this.totalEntries > 0;
        }
        get resizeModal() {
            return this.currentRunningEntry.enableCrossover == false ? "xl" : "md";
        }
        get firstEntry() {
            return _.sortBy(this.allEntriesForTheDay, "startTime")[0];
        }
        get weekStartDate() {
            const startOfWeek = this.getStartOfWeek(this.today);
            const startOfTheWeek = this.formattedWeekDate(startOfWeek);
            return startOfTheWeek;
        }
        get weekEndDate() {
            const endOfWeek = this.getEndOfWeek(this.today);
            const endOfTheWeek = this.formattedWeekDate(endOfWeek);
            return endOfTheWeek;
        }
        getEntryDay(displayDate) {
            const formattedDate = new Date();
            this.getFormattedDate(displayDate);
            return formattedDate;
        }
        getFormattedDate(date) {
            this.formattedDate = {
                dateOfMonth: format(date, "do").slice(0, -2),
                suffixOfDate: format(date, "do").slice(-2),
                month: format(date, "MMM"),
                year: format(date, "yyyy"),
                day: format(date, "EEEE"),
            };
            return this.formattedDate;
        }
        formattedWeekDate(date) {
            const originalDate = new Date(date);
            const day = originalDate.getDate();
            const month = originalDate.toLocaleString("default", { month: "short" });
            const year = originalDate.getFullYear();
            const formattedDay = day + (day === 1 ? "st" : day === 2 ? "nd" : day === 3 ? "rd" : "th");
            const formattedDate = formattedDay + " " + month + " " + year;
            const dayOfWeek = originalDate.toLocaleString("default", {
                weekday: "long",
            });
            const formattedWeekDate = formattedDate + ", " + dayOfWeek;
            return formattedWeekDate;
        }
        changeRunningEntry() {
            this.isAMorPM = false;
            this.isAM = false;
            this.runningEntries.forEach((x) => (x.clockWorkEntry.endTimeTzFormatted = "now"));
            var clockPicker = this.$refs["runningEntryEndTime"];
            this.resetClockPicker(clockPicker);
        }
        resetClockPicker(clockPicker) {
            if (clockPicker) {
                clockPicker.choosingHour = true;
                clockPicker.hour = undefined;
                clockPicker.minute = undefined;
                clockPicker.hourHover = undefined;
                clockPicker.minuteHover = undefined;
                clockPicker.time = undefined;
            }
        }
        get lastEntry() {
            return _.sortBy(this.allEntriesForTheDay, "startTime").reverse()[0];
        }
        get totalTime() {
            var completedTime = _.sumBy(this.allEntriesForTheDay.filter((x) => !this.activeEntry || x.id != this.activeEntry.id), "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allEntriesForTheDay.some((x) => x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTimeString(completedTime + currentRunTime);
        }
        get formattedWeekTotalTime() {
            let unEntries = this.allWeekEntries;
            var completedTime = _.sumBy(this.allWeekEntries.filter((x) => !this.activeEntry || x.id != this.activeEntry.id), "totalTimeInSeconds");
            var currentRunTime = this.isActive && unEntries.some((x) => x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get dayTotalTime() {
            var completedTime = _.sumBy(this.allEntriesForTheDay.filter((x) => !this.activeEntry || x.id != this.activeEntry.id), "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allEntriesForTheDay.some((x) => x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get unassignedEntriesTime() {
            let unEntries = this.allEntriesForTheDay.filter((x) => x.projectDisplayString == "Unassigned" && (!this.activeEntry || x.id != this.activeEntry.id));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allEntriesForTheDay.some((x) => x.projectDisplayString == "Unassigned" && x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get unassignedWeekEntriesTime() {
            let unEntries = this.allWeekEntries.filter((x) => x.projectDisplayString == "Unassigned" && (!this.activeEntry || x.id != this.activeEntry.id));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allWeekEntries.some((x) => x.projectDisplayString == "Unassigned" && x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get workFromOfficeEntriesTime() {
            let unEntries = this.allEntriesForTheDay.filter((x) => x.entryAtWork == true && (!this.activeEntry || x.id != this.activeEntry.id));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allEntriesForTheDay.some((x) => x.entryAtWork == true && x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get workFromOfficeWeekEntriesTime() {
            let unEntries = this.allWeekEntries.filter((x) => x.entryAtWork == true && (!this.activeEntry || x.id != this.activeEntry.id));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allWeekEntries.some((x) => x.entryAtWork == true && x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get workFromHomeEntriesTime() {
            let unEntries = this.allEntriesForTheDay.filter((x) => x.entryAtWork != true && (!this.activeEntry || x.id != this.activeEntry.id));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allEntriesForTheDay.some((x) => x.entryAtWork != true && x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get workFromHomeWeekEntriesTime() {
            let unEntries = this.allWeekEntries.filter((x) => x.entryAtWork != true && (!this.activeEntry || x.id != this.activeEntry.id));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.allWeekEntries.some((x) => x.entryAtWork != true && x.id == this.activeEntry.id) ? this.runningTime : 0;
            return this.formattedTime(completedTime + currentRunTime);
        }
        get checkedEntriesTime() {
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.multiSelection")) {
                var multiEntries = this.allEntriesForTheDay.filter((x) => this.checkedEntries.indexOf(x.id) > -1 && (!this.activeEntry || x.id != this.activeEntry.id));
                var completedTime = _.sumBy(multiEntries, "totalTimeInSeconds");
                var currentRunTime = this.isActive && this.allEntriesForTheDay.some((x) => x.id == this.activeEntry.id) ? this.runningTime : 0;
                return this.formattedTimeString(completedTime + currentRunTime);
            }
        }
        get runningTime() {
            var runningTime = 0;
            runningTime = this.isToday ? this.liveTime : 0;
            return runningTime;
        }
        get entries() {
            return _.sortBy(ClockWorkModule.entries.filter((x) => x.endTime != null), ["startTime", "endTime"]).reverse();
        }
        get isActive() {
            return this.activeEntry != null && this.activeEntry != undefined;
        }
        // get anyRunningData(): ClockWorkRunningEntryModel {
        //     return ClockWorkModule.clockWorkNullEntries.find((x) => x.clockWorkEntry.endTime == null);
        // }
        get runningEntries() {
            return ClockWorkModule.clockWorkNullEntries;
        }
        get anyNull() {
            return this.runningEntries && this.runningEntries.length > 0;
        }
        get activeEntry() {
            return ClockWorkModule.entries.find((x) => x.endTime == null);
        }
        get selectedEntry() {
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection")) {
                return this.allEntriesForTheDay.find((x) => x.id == this.state.context.checkedEntries[0]);
            }
            return null;
        }
        get selectedEntryProjectAndTask() {
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection")) {
                const selected = this.allEntriesForTheDay.find((x) => x.id === this.state.context.checkedEntries[0]);
                if (selected.taskId != null) {
                    if (this.defaultProjectAndTask) {
                        if (this.defaultProjectAndTask.taskId.toString() == selected.taskId.toLowerCase()) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            }
            return true;
        }
        get firstOfManySelectedEntries() {
            if (this.state.matches("clockWorkOpertations.review.dayLoaded.multiSelection")) {
                return this.allEntriesForTheDay.find((x) => x.id == this.state.context.checkedEntries[0]);
            }
            return null;
        }
        get multiEntriesHaveSameCombo() {
            var multiEntries = this.allEntriesForTheDay.filter((x) => this.checkedEntries.indexOf(x.id) > -1);
            const allProjectsEqual = multiEntries.every((v) => v.projectDisplayString === multiEntries[0].projectDisplayString);
            const allTasksEqual = multiEntries.every((v) => v.taskDisplayString === multiEntries[0].taskDisplayString);
            return allProjectsEqual && allTasksEqual;
        }
        get isActiveEntryIsSinglySelected() {
            return this.activeEntry !== null && this.selectedEntry !== null && this.activeEntry === this.selectedEntry;
        }
        get isToday() {
            return this.state.context.operationDate.toDateString() == this.state.context.displayDate.toDateString();
        }
        get panelOpen() {
            return this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection") || this.state.matches("clockWorkOpertations.review.dayLoaded.multiSelection");
        }
        get featuresMode() {
            return this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection.features") || this.state.matches("clockWorkOpertations.review.dayLoaded.multiSelection.features");
        }
        get projectTaskCombos() {
            return ProjectModule.projectTaskCombos;
        }
        get hasProjectTaskCombos() {
            return ProjectModule.projectTaskCombos.length > 0;
        }
        get newProjectTaskCombo() {
            return ProjectModule.newProjectTaskCombo;
        }
        get filteredProjectSelections() {
            if (this.projectSearchKey != "") {
                return ProjectModule.projectSelections.filter((o) => {
                    return o.value.toLowerCase().indexOf(this.projectSearchKey.toLowerCase()) > -1 || o.code.toLowerCase().indexOf(this.projectSearchKey.toLowerCase()) > -1;
                });
            }
            return ProjectModule.projectSelections;
        }
        get filteredTaskSelections() {
            if (this.taskSearchKey != "") {
                return ProjectModule.taskSelections.filter((o) => {
                    return o.value.toLowerCase().indexOf(this.taskSearchKey.toLowerCase()) > -1 || o.code.toLowerCase().indexOf(this.taskSearchKey.toLowerCase()) > -1;
                });
            }
            return ProjectModule.taskSelections;
        }
        get taskNotFound() {
            return this.taskSearchKey != "" && this.filteredTaskSelections.length == 0;
        }
        // Default Project and Task
        get allTasks() {
            return _.sortBy(ProjectModule.allTasksForDefault, (item) => parseInt(item.code));
        }
        get SearchedAllTasks() {
            if (this.selectedTaskName != "") {
                const matchedTasks = this.allTasks.filter((task) => task.code.toLowerCase().includes(this.selectedTaskName.toLowerCase()) || task.value.toLowerCase().includes(this.selectedTaskName.toLowerCase()));
                return matchedTasks;
            }
            else {
                return this.allTasks;
            }
        }
        get SearchedAllProject() {
            if (this.selectedProjectName != "") {
                const matchedProjects = this.allProjects.filter((project) => project.code.toLowerCase().includes(this.selectedProjectName.toLowerCase()) || project.value.toLowerCase().includes(this.selectedProjectName.toLowerCase()));
                return matchedProjects;
            }
            else {
                return this.allProjects;
            }
        }
        get allProjects() {
            return _.sortBy(ProjectModule.allProjectsForDefault, (item) => parseInt(item.code));
        }
        get defaultProjectAndTask() {
            return ClockWorkModule.defaultProjectAndTask;
        }
        get isClockWorkSetWeeklyMail() {
            return ClockWorkModule.isClockWorkSetWeeklyMail;
        }
        get isWorkFromOffice() {
            return ClockWorkModule.isWFO;
        }
        get isGuidEmpty() {
            return this.taskId.isEmpty;
        }
        get keymap() {
            return {
                // 'esc+ctrl' is OK.
                "shift+n": this.addEntry,
                j: this.prevEntry,
                k: this.nextEntry,
                h: this.prevDay,
                l: this.nextDay,
                "/": this.showCWSearchFlap,
            };
        }
        projectTaskTooltip(value) {
            return value.length > 23 ? value : null;
        }
        // LIFECYCLE
        created() {
            this.TimeInterval();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                this.today = this.state.context.displayDate;
                this.getEntryDay(this.today);
                this.TimeInterval();
                this.closeKsWindow();
                if (this.state.matches("clockWorkOpertations.operations.running") && this.previousState.matches("clockWorkOpertations.operations.starting")) {
                    this.setFocusToInputAndSelect("txtLiveEntryDesc");
                }
                if (this.state.matches("#clockWork.checkingLongRunningEntries")) {
                    this.showLongRunningEntry = false;
                    this.$bvModal.hide("long-running-entry");
                }
                if (this.state.matches("clockWorkOpertations.settings.savingDefaultTask") || this.state.matches("clockWorkOpertations.settings.idle")) {
                    this.selectedTaskName = "";
                    this.selectedProjectName = "";
                    this.showSettingsCard = false;
                }
                if (this.state.matches("longRunningEntry.entryNeedsFix") && this.state.hasTag("long-running-entry")) {
                    if (!this.currentRunningEntry || !this.runningEntries.some((x) => x.clockWorkEntry.id == this.currentRunningEntry.clockWorkEntry.id)) {
                        this.currentRunningEntry = this.runningEntries[0];
                    }
                    Vue.nextTick(() => {
                        this.$bvModal.show("long-running-entry");
                    });
                    this.isAMorPM = false;
                    this.isAM = false;
                    this.checkingAMOrPM(this.currentRunningEntry.clockWorkEntry.id);
                    var clockPicker = this.$refs["runningEntryEndTime"];
                    this.resetClockPicker(clockPicker);
                }
                if (this.state.matches("clockWorkOpertations.settings.idle")) {
                    this.projectId = Guid.createEmpty();
                    this.taskId = Guid.createEmpty();
                }
                if (this.state.matches("clockWorkOpertations.review.dayLoaded") && this.isActive && this.firstTime) {
                    this.firstTime = false;
                    this.send({ type: "RESUME_RUNNING" });
                }
                if (this.previousState.matches("clockWorkOpertations.operations.starting") && this.state.matches("clockWorkOpertations.operations.running")) {
                    if (!this.isToday) {
                        this.send({ type: "GO_TO_TODAY" });
                    }
                }
                if (this.state.matches("clockWorkOpertations.review.dayLoaded.nullSelection")) {
                    this.checkedEntries = this.state.context.checkedEntries;
                    this.checkAll = false;
                    this.clearProjectTaskSelections();
                }
                if (this.state.matches("clockWorkOpertations.review.dayLoaded.singleSelection")) {
                    this.checkedEntries = this.state.context.checkedEntries;
                }
                if (this.state.context.associationMachine != null) {
                    if (this.state.hasTag("displaying") && this.state.context.associationMachine.state.matches("recentCombosLoaded")) {
                        this.clearProjectTaskSelections();
                        this.preselectProjectTaskCombo();
                    }
                }
            });
            this.machineService.start();
        }
        destroyed() {
            clearInterval(this.Interval);
            this.machineService.stop();
        }
    };
    __decorate([
        Watch("isWFO"),
        Watch("selectedTaskName"),
        Watch("isClockWorkWeeklyMail"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClockWork.prototype, "changesInDefaultClockWorkSettings", null);
    ClockWork = __decorate([
        Component({
            name: "ClockWork",
            components: {
                Loader,
                SectionLoader,
                Layout,
                PageHeader,
                simplebar,
                Timer,
                HeartBeat,
                clockPicker,
                TimeLine,
                ClockWorkSearch,
                Switches,
                VueApexChart,
                ClockWorkPieChart,
                AdjustEntrySlider,
            },
        })
    ], ClockWork);
    return ClockWork;
})();
export default ClockWork;
